(function(angular, wijmo){
    'use strict';

    angular.module('onvio.setup.migrations').controller('onvio.setup.migrations.FileCabinetFormController', fileCabinetFormCtrl);

    fileCabinetFormCtrl.$inject = ['$scope', '$q', '$translate', '$stateParams', '$uibModal', 'migrationService',
        'AuthenticatedSessionData', 'bmpFlexGridSetUpFactory', 'migrationApps', 'bmpConfirmationDialog'];

    function fileCabinetFormCtrl($scope, $q, $translate, $stateParams, $uibModal, migrationService, authenticatedSessionData,
        bmpFlexGridSetUpFactory, migrationApps, bmpConfirmationDialog) {

        /*jshint validthis:true */
        var vm = this;
        vm.bmpFlexGridSetUpService = bmpFlexGridSetUpFactory.makeService();
        vm.companyId = vm.migrationConfig.companyId;
        vm.contactId = vm.migrationConfig.contactId;

        $scope.itemsList = [];
        $scope.params = {
            orderBy: 'id',
            search: '',
            searchBy: '',
            filter: '',
            startIndex: 0,
            itemsPerPage: 25
        };
        $scope.gridData = {
            currentPageItemCount: 0,
            pageCount: 1,
            currentPage: 1,
            itemsPerPage: 25,
            totalItemCount: 0,
            pageSizeOption: [
                {value: 10, label: 10},
                {value: 25, label: 25},
                {value: 50, label: 50}
            ],
            changePageSize: function(size) {
                $scope.gridData.itemsPerPage = size;
                $scope.ctx.flexGrid.itemsSource.pageSize = size;
                $scope.ctx.flexGrid.invalidate(true);
            },
            changePage: function(page) {
                $scope.ctx.flexGrid.itemsSource.moveToPage(page - 1);
            }
        };
        $scope.busyLoading = false;
        $scope.loadingFailed = false;

        $scope.getFcMigrationList = function() {
            $scope.busyLoading = true;
            $scope.loadingFailed = false;
            $scope.itemsList.splice(0, $scope.itemsList.length);
            migrationService.getMigrationList(vm.companyId, migrationApps.fileCabinet)
            .then( function(resp) {
                resp.items.forEach( function(item) {
                    $scope.itemsList.push(item);
                });
                $scope.gridData.totalItemCount = $scope.itemsList.length;
                return $scope.itemsList;
            }, function() {
                $scope.loadingFailed = true;
                return $scope.itemsList;
            })
            .finally(function() {
                $scope.busyLoading = false;
                vm.refreshGrid();
            });
        };

        vm.refreshGrid = function() {
            var cview = new wijmo.collections.CollectionView($scope.itemsList);
            cview.pageSize = $scope.gridData.itemsPerPage;
            cview.filter = vm.itemsListFilter;
            $scope.ctx.flexGrid.itemsSource =  cview;
            $scope.ctx.flexGrid.invalidate(true);
        };

        vm.itemsListFilter = function(item) {
            if (!$scope.searchTerm || !$scope.searchTerm.trim()) {
                return true;
            }
            var searchExp = new RegExp($scope.searchTerm, 'i');
            if (item.drawers && (item.drawers.search(searchExp) >= 0)) {
                return true;
            } else if (item.description && (item.description.search(searchExp) >= 0)) {
                return true;
            }
            var status = $scope.getStatusText(item);
            if (status.search(searchExp) >= 0) {
                return true;
            }
            return false;
        };

        $scope.searchTerm = '';
        $scope.onSearch = function() {
            $scope.ctx.flexGrid.itemsSource.refresh();
        };

        // load data into the grid
        $scope.getFcMigrationList();

        $scope.ctx = {
            flexGrid: null,
            pageSize: 25,
            page: 1,
            itemPerPageOptions: [{
                value: 10,
                label: 10
            }, {
                value: 25,
                label: 25
            }, {
                value: 50,
                label: 50
            }],
        };

        // use the "control" attribute to initialize the first grid
        $scope.$watch('ctx.flexGrid', function() {
            var flex = $scope.ctx.flexGrid;
            if (flex) {
                vm.setGridOptions(flex);
                vm.setupPagination();
            }
        });

        // same setup as in bm-practive-common.js
        vm.setGridOptions = function(flex) {
            //var rowHeight = 37;
            //var headerHeight = 48;
            var rowHeight = 30;
            var headerHeight = 40;
            vm.bmpFlexGridSetUpService.updateFlexGridRowHeight(flex, rowHeight, headerHeight);
        };

        vm.setupPagination = function() {
            /*
            if ($scope.ctx.flexGrid) {
                $scope.$watch("ctx.page", function(page) {
                    $scope.ctx.flexGrid.collectionView.moveToPage(page - 1);
                });

                $scope.$watch("ctx.pageSize", function(pageSize) {
                    $scope.ctx.flexGrid.collectionView.pageSize = pageSize;
                });

                $scope.ctx.flexGrid.collectionView.pageSize = $scope.ctx.pageSize;
            }
            */
        };

        $scope.itemFormatter = function(panel, r, c, cell) {
            if (panel.cellType === wijmo.grid.CellType.ColumnHeader) {
                // center-align vertically
                if (cell.children.length === 0) {
                    cell.innerHTML = '<div>' + cell.innerHTML + '</div>';
                }
                wijmo.setCss(cell.children[0], {
                    position: 'relative',
                    top: '50%',
                    transform: 'translateY(-50%)'
                });
            }
        };

        $scope.hasNoData = function() {
            return ($scope.itemsList.length === 0)? true : false;
        };

        $scope.actions = {
            pauseRow: function() {
                //alert('Stop item: ' + item.id);
            },
            closeRow: function(item) {
                bmpConfirmationDialog.open({
                    titleText: '',
                    bodyText: vm.getDeleteMessage(item),
                    confirmText: $translate.instant('Onvio.Setup.Common.Buttons.Delete'),
                    cancelText: $translate.instant('Bluemoon.Practice.Common.Actions.Cancel')
                }).then(function() {
                    vm.deleteMigration(item);
                });
            },
            editRow: function() {
                //alert('Edit item: ' + item.id);
            },
            editDocRow: function() {
                //alert('Edit doc item: ' + item.id);
            },
            toggleDetail: function(row, dp) {
                if (dp.isDetailVisible(row)) {
                    dp.hideDetail(row);
                } else {
                    dp.showDetail(row);
                }
            }
        };

        vm.getDeleteMessage = function(item) {
            var text = $scope.fctrans('DeleteMessage');
            if (item.uploadedDrawers) {
                text = text + ' - Migrated: ' + item.uploadedDrawers;
            }
            return text;
        };

        vm.deleteMigration = function(item) {
            var pos = vm.findItemIndex(item);
            if (pos < 0 ) {
                return;
            }
            $scope.busyLoading = true;
            migrationService.deleteMigration(vm.companyId, vm.contactId, item.migrationId)
            .then( function() {
                $scope.busyLoading = false;
            }, function() {
                $scope.busyLoading = false;
            })
            .finally(function() {
                $scope.busyLoading = false;
            });
            $scope.itemsList.splice(pos, 1);
            vm.refreshGrid();
        };

        vm.findItemIndex = function(item) {
            var deleteId = item.migrationId;
            var pos = -1;
            var i;
            for(i = 0; i < $scope.itemsList.length; i++) {
                var obj = $scope.itemsList[i];
                var objId = obj.migrationId;
                if (deleteId === objId) {
                    pos = i;
                    break;
                }
            }
            return pos;
        };

        $scope.itemProgressPercent = function(item) {
            if (angular.isUndefined(item) || angular.isUndefined(item.uploadedCount) || angular.isUndefined(item.totalCount)) {
                return 0;
            }
            return item.uploadedCount * 100 / item.totalCount;
        };

        $scope.itemProgressLabel = function(item) {
            if (angular.isUndefined(item) || angular.isUndefined(item.uploadedCount) || angular.isUndefined(item.totalCount)) {
                return '';
            }
            return item.uploadedCount + '/' + item.totalCount;
        };

        $scope.itemProgressType = function(item) {
            if (angular.isUndefined(item) || angular.isUndefined(item.status)) {
                return 'warning';
            }
            if (item.status === 'Complete') {
                return 'success';
            } else if (item.status === 'Info.Needed') {
                return 'danger';
            } else {
                return '';
            }
        };

        $scope.getStartDate = function(item) {
           return migrationService.getDateStringShort(item.startDate);
        };

        $scope.getStatusText = function(item) {
            if (angular.isUndefined(item) || angular.isUndefined(item.status)) {
                return '';
            }
            // work-around for dynamic keys so they'll not be cut off aftre grunt i18n
            if (item.status === 'In.Progress') {
                return $translate.instant('Onvio.Migrations.Status.In.Progress');
            } else if (item.status === 'Info.Needed') {
                return $translate.instant('Onvio.Migrations.Status.Info.Needed');
            } else if (item.status === 'Complete') {
                return $translate.instant('Onvio.Migrations.Status.Complete');
            } else {
                var str = 'Onvio.Migrations.Status.' + item.status;
                return $translate.instant(str);
            }
        };

        $scope.fctrans = function(text) {
            // work-around for dynamic keys so they'll not be cut off aftre grunt i18n
            if (text === 'DeleteMessage') {
                return $translate.instant('Onvio.Migrations.FileCabinet.DeleteMessage');
            } else if (text === 'Actions') {
                return $translate.instant('Onvio.Migrations.FileCabinet.Actions');
            } else if (text === 'StartDate') {
                return $translate.instant('Onvio.Migrations.FileCabinet.StartDate');
            } else if (text === 'Drawers') {
                return $translate.instant('Onvio.Migrations.FileCabinet.Drawers');
            } else if (text === 'Description') {
                return $translate.instant('Onvio.Migrations.FileCabinet.Description');
            } else if (text === 'Status') {
                return $translate.instant('Onvio.Migrations.FileCabinet.Status');
            } else if (text === 'Size') {
                return $translate.instant('Onvio.Migrations.FileCabinet.Size');
            } else if (text === 'SelectedDrawers') {
                return $translate.instant('Onvio.Migrations.FileCabinet.SelectedDrawers');
            } else if (text === 'Attention') {
                return $translate.instant('Onvio.Migrations.FileCabinet.Attention');
            } else {
                return $translate.instant('Onvio.Migrations.FileCabinet.' + text);
            }
        };

    }

})(window.angular, window.wijmo);
